import React from "react";
import InnerHTML from "../base/InnerHtml";

const Banner = () => {
  return (
    <InnerHTML
      className=""
      html={`<ins class="asm_async_creative" style="display:inline-block; width:300px; height:600px;text-align:left; text-decoration:none;" data-asm-cdn="cdn.web2media.sk" data-asm-host="turbo.web2media.sk" data-asm-params="pid=717&gdpr_consent=[consentstring]"></ins><script src="//cdn.web2media.sk/adasync.min.js" async type="text/javascript"></script> `}
    ></InnerHTML>
  );
};

export const Web2MediaBanner300 = Banner;

export default Banner;
